export enum MutationTypes {
    SET_TEMPLATES = 'templates/set-templates',
    SET_TEMPLATES_META = 'templates/set-templates-meta',
    SET_TEMPLATE = 'templates/set-template',
    SET_FILTERED_TEMPLATES = 'templates/set-filtered-templates',
    SET_USERS_FOR_ACCESS = 'inspection-templates/set-users-for-access',
    SET_TEMPLATE_TAGS = 'templates/set-template-tags'
}
